module.exports = __webpack_public_path__ + "assets/img/bg-shadow-28699cd4.png";